import { render, staticRenderFns } from "./instance-misp.vue?vue&type=template&id=63e790af&"
import script from "./instance-misp.vue?vue&type=script&lang=js&"
export * from "./instance-misp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports